if (!customElements.get("custom-select")) {
    class CustomSelect extends HTMLElement {
      constructor() {
        super();
  
        this.selectEl = this.querySelector("select");
  
        this.createCustomSelect();
  
        this.dropdown = this.querySelector(".js-dropdown");
        this.btnToggleDropdown = this.querySelector(".js-btn-dropdown");
        this.listOptions = this.querySelector(".js-list-options");
        this.isExpanded = false;
  
        this.selectLabel = this.getAttribute("data-label");
  
        this.setBtnWidth();
  
        window.addEventListener("DOMContentLoaded", () => {
          this.setBtnWidth();
        });
  
        window.addEventListener("shopify:section:load", () => {
          clearTimeout(this.loadTimeout);
  
          this.loadTimeout = setTimeout(() => {
            this.setBtnWidth();
          }, 300);
        });
  
        window.addEventListener("resize", () => {
          const isMobileMedium = window.innerWidth < tabletWidth;
  
          if (isMobileMedium) {
            return;
          }
  
          const isWidthUnchanged =
            +this.btnToggleDropdown.style.width.replace("px", "") ===
            this.dropdown.clientWidth;
  
          if (isWidthUnchanged) {
            return;
          }
  
          this.btnToggleDropdown.style.width = `${this.dropdown.clientWidth}px`;
        });
  
        this.btnToggleDropdown.addEventListener("click", e => {
          e.preventDefault();
  
          const isExpanded = this.classList.contains("is-expanded");
  
          if (isExpanded) {
            this.hideDropdown();
  
            return;
          }
  
          this.showDropdown();
        });
  
        this.btnToggleDropdown.addEventListener("keydown", e => {
          if (e.key.includes("Arrow")) {
            e.preventDefault();
  
            const isArrowRight = e.key.includes("Right");
            const isHorizontalArrow =
              e.key.includes("Left") || isArrowRight;
  
            if (this.isExpanded && isHorizontalArrow) {
              return;
            }
  
            const isNextKey = isArrowRight || e.key.includes("Down");
  
            const btnOptionSelected = this.listOptions.querySelector(
              ".js-btn-option.is-selected"
            );
            const selectedOptionParent =
              btnOptionSelected.parentElement;
            let prevNextBtnOption = isNextKey
              ? selectedOptionParent.nextElementSibling
                  ?.firstElementChild
              : selectedOptionParent.previousElementSibling
                  ?.firstElementChild;
  
            if (!prevNextBtnOption) {
              prevNextBtnOption = isNextKey
                ? this.listOptions.firstElementChild.firstElementChild
                : this.listOptions.lastElementChild.firstElementChild;
            }
  
            this.changeSelectedOption(
              btnOptionSelected,
              prevNextBtnOption
            );
  
            return;
          }
  
          if (!this.isExpanded) {
            return;
          }
  
          const isEscape = e.key === "Escape";
          const isTab = e.key === "Tab";
  
          if (!isEscape && !isTab) {
            return;
          }
  
          e.preventDefault();
  
          this.hideDropdown();
        });
  
        this.listOptions.addEventListener("click", e => {
          const isBtnOption =
            e.target.classList.contains("js-btn-option");
  
          if (!isBtnOption) {
            return;
          }
  
          e.preventDefault();
  
          const btnOption = e.target;
          const isSelected =
            btnOption.classList.contains("is-selected");
  
          this.hideDropdown();
  
          if (isSelected) {
            return;
          }
  
          this.changeSelectedOption(undefined, btnOption);
        });
  
        document.addEventListener("click", e => {
          if (!this.isExpanded) {
            return;
          }
  
          const isThisSelect =
            e.target.closest("custom-select") === this;
  
          if (isThisSelect) {
            return;
          }
  
          this.hideDropdown();
        });
      }
  
      setBtnWidth() {
        this.btnToggleDropdown.style.width = `240px`;
      }
  
      createCustomSelect() {
          const selectLabel = this.getAttribute("data-label");
          const options = this.querySelectorAll("option");
          const selectedOption = this.selectEl.querySelector('option[selected="selected"]') || this.selectEl.options[0];

          let optionsMarkup = "";

          options.forEach(option => {
            const value = option.value.toLowerCase();
            const text = option.textContent.toLowerCase();
            if (
              value.includes("price") ||
              value.includes("featured") ||
              text.includes("prezzo") ||
              text.includes("price") ||
              text.includes("featured") ||
              value === "manual"
            ) {
              return; 
            }
            const optionMarkup = `
              <li class="custom-select__item py-2 pl-10 relative pr-3">
                <button
                  type="button"
                  class="custom-select__option button-reset js-btn-option ${option.selected ? "is-selected" : ""}"
                  data-value="${option.value}"
                  tabindex="-1"
                  aria-selected="${option.selected}"
                >
                  ${option.textContent}
                </button>
              </li>
            `;
            optionsMarkup += optionMarkup;
          });

          const markup = `
            <div class="custom-select__wrapper">
              <button
                type="button"
                class="custom-select__btn button-reset focus-inset js-btn-dropdown flex"
                aria-controls="${this.dataset.dropdownId}"
                aria-expanded="false"
              >
                <span class="b3 flex items-center">
                  ${selectLabel}: 
                  <span class="ml-1 font-medium hidden md:block" style="margin-left:5px;">${selectedOption.textContent}</span>
                </span>
                <svg class="arrow-down-facet" width="20" height="20" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24.375 10.3125L15 19.6875L5.625 10.3125" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>   
              </button>

              <div class="custom-select__dropdown absolute max-w-full js-dropdown mt-0 md:max-w-60 left-0 w-screen md:w-auto md:left-auto" id="${this.dataset.dropdownId}">
                <ul class="custom-select__items b3 list-unstyled js-list-options bg-white text-left border py-1">
                  ${optionsMarkup}
                </ul>
              </div>
            </div>
          `;

          this.insertAdjacentHTML("afterbegin", markup);
          this.dataset.value = selectedOption.value;
        }
  
      changeSelectedOption(
        selectedOption = this.listOptions.querySelector(
          ".js-btn-option.is-selected"
        ),
        newSelectedOption
      ) {
       //this.btnToggleDropdown.textContent = this.selectLabel + ": " + newSelectedOption.textContent;   VERIFICARE
        this.dataset.value = newSelectedOption.dataset.value;
  
        newSelectedOption.classList.add("is-selected");
        newSelectedOption.setAttribute("aria-selected", true);
  
        selectedOption.classList.remove("is-selected");
        selectedOption.setAttribute("aria-selected", false);
  
        const nativeSelectedOption = this.selectEl.querySelector(
          'option[selected="selected"]'
        );
        const newNativeSelectedOption = this.selectEl.querySelector(
          `option[value="${this.dataset.value}"]`
        );
  
        nativeSelectedOption.removeAttribute("selected");
        newNativeSelectedOption.setAttribute("selected", "selected");
  
        // Trigger input event
  
        const inputEvent = new Event("input", { bubbles: true });
  
        this.selectEl.dispatchEvent(inputEvent);
      }
  
      showDropdown() {
        this.isExpanded = true;
        this.classList.add("is-expanded");
        this.btnToggleDropdown.setAttribute("aria-expanded", true);
        this.btnToggleDropdown.querySelector(".arrow-down-facet")?.classList.add("rotate-180");

      }
  
      hideDropdown() {
        this.isExpanded = false;
        this.classList.remove("is-expanded");
        this.btnToggleDropdown.setAttribute("aria-expanded", false);
        this.btnToggleDropdown.querySelector(".arrow-down-facet")?.classList.remove("rotate-180");

      }
    }
  
    customElements.define("custom-select", CustomSelect);
  }
  